import { admin } from '#@/platform/networking/client/lib/stubs/admin.stub'
import { getAuthHeaders } from '#@/platform/networking/client/lib/stubs/getAuthHeaders.stub'
import { getClientHeaders } from '#@/platform/networking/client/lib/stubs/getClientHeaders.stub'
import { getServiceUrl } from '#@/platform/networking/client/lib/stubs/getServiceUrl.stub'

export type Config = {
  initialized: boolean
  extensions: { admin: typeof admin }
  utilities: {
    getAuthHeaders: typeof getAuthHeaders
    getClientHeaders: typeof getClientHeaders
    getServiceUrl: typeof getServiceUrl
  }
  // Optional fetch override applied to every GraphQL request. Apps in CF Workers
  // can route specific endpoints through service bindings here.
  customFetch?: typeof fetch
}

// `setClientConfig` writes this singleton through `Object.assign`, and the annotation carries `customFetch`, which the
// literal never sets. Both need the annotation, so the literal must stay mutable.
// oxlint-disable-next-line district/exported-literal-as-const -- mutable singleton, see above
export const config: Config = {
  initialized: false,
  extensions: { admin },
  utilities: { getAuthHeaders, getClientHeaders, getServiceUrl },
}
